import {AsxGameService} from "./service/AsxGameService";
import {LeagueInviteService} from "./partials/leagues/invite/LeagueInviteService";

import Achievements from "./achievements";

export default angular.module("tfApp.game", [Achievements()])
                      .service(AsxGameService.id, AsxGameService)
                      .service(LeagueInviteService.id, LeagueInviteService)
                      .name;
